import React, { useContext, useEffect, useState } from "react";
import { NavTreeContext } from "./context/context";
import { List } from "./list";

const NavTree = () => {
  const [ready, setReady] = useState(false);
  const navTreeContext = useContext(NavTreeContext);

  useEffect(() => {
    const loadData = async () => {
      await navTreeContext.reload();
      setReady(true);
    };

    loadData();
  }, [navTreeContext]);

  // Handle initial active node selection after React NavTree is loaded
  useEffect(() => {
    if (ready && navTreeContext.nodes.length > 0) {
      if (
        typeof window !== "undefined" &&
        !window.reactNavTreeReadyDispatched
      ) {
        window.reactNavTreeReadyDispatched = true;

        if (window.m_currentRestartNode) {
          const restartNodeId = window.m_currentRestartNode;
          if (restartNodeId && restartNodeId !== "0") {
            // Set the active node in the React context
            navTreeContext.setSelectedNode(restartNodeId);

            // Also update the URL to reflect the selected node
            if (window.luvitedu) {
              window.luvitedu.expandTreeToNode(restartNodeId);
            }
          }
        }

        // Dispatch a custom event to notify that React NavTree is ready
        window.dispatchEvent(
          new CustomEvent("reactNavTreeReady", {
            detail: { nodes: navTreeContext.nodes },
          }),
        );
      }
    }
  }, [ready, navTreeContext.nodes.length]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.setReactNavTreeActiveNode = (navTreeId) => {
        if (navTreeContext.containsNode(navTreeId)) {
          navTreeContext.setSelectedNode(navTreeId);
          return true;
        }
        return false;
      };
    }
  }, [navTreeContext.containsNode, navTreeContext.setSelectedNode]);

  const onToggleVisible = (e) => {
    navTreeContext.toggleNode(e);
  };

  const treeNodeClicked = (e) => {
    navTreeContext.setSelectedNode(e.currentTarget.parentElement.id);
    document.querySelectorAll(".navtree li.active").forEach((item) => {
      item.classList.remove("active");
    });
    e.currentTarget.classList.add("active");
    // Function in main.aspx
    if (typeof window !== "undefined" && window.TreeNodeClicked) {
      window.TreeNodeClicked(e.currentTarget, e.currentTarget.parentElement.id);
      document.getElementById("divMainContent").focus();
    }
  };

  const handleReloadTree = () => {
    navTreeContext.reload({ force: true });
  };

  const buildNestedHierarchy = (nodes) => {
    if (!nodes || !nodes.length) return nodes || [];

    const tempNodes = nodes.slice();

    const nodeObjs = Object.fromEntries(tempNodes.map((n) => [n.navTreeID, n]));
    const rootNodes = [];

    // Reset to avoid duplicates, solve some other way?
    tempNodes.forEach((n) => {
      const node = n;
      node.childNodes = [];
    });

    tempNodes.forEach((n) => {
      const parent = nodeObjs[n.parent];
      if (!parent) {
        const node = n;
        node.childNodes = [];
        rootNodes.push(n);
      } else {
        if (!parent.childNodes) parent.childNodes = [];
        parent.childNodes.push(n);
      }
    });

    return rootNodes;
  };

  if (!ready) return <div />;

  return (
    <>
      <List
        list={buildNestedHierarchy(navTreeContext.nodes)}
        root={true}
        onClick={(e) => treeNodeClicked(e)}
        onExpandToggle={(e) => onToggleVisible(e)}
      />
      <Toolbar onReload={handleReloadTree} />
    </>
  );
};

const Toolbar = ({ onReload }) => {
  return (
    <div id="divToolbarBottom" className="toolbar-bottom ">
      <button id="BtnReloadTree" onClick={onReload} />
    </div>
  );
};

export default NavTree;
